
    
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ConsentAdjournment extends Vue {    

    @Prop({required: true})
    instructionsStep!: string;
    
}
